// @ts-nocheck
import console from "../../log";
import { isCartRefreshRequest, scheduleInitialize } from "./cartRequests";
export default function fetchOverride(initialize) {
    // isEligble runs on every initialize(); only wrap fetch once per page.
    if (window.__realIdFetchOverrideInstalled)
        return;
    window.__realIdFetchOverrideInstalled = true;
    (function (ns, fetch) {
        if (typeof fetch !== "function")
            return;
        ns.fetch = function (...args) {
            console.debug("Real ID :: Shopify :: applying fetch override");
            const response = fetch.apply(this, args);
            response
                .then((res) => {
                if (!isCartRefreshRequest(res.url))
                    return;
                // Resolution means headers only; themes render after reading the
                // body, so wait for a clone of it before rescanning.
                res
                    .clone()
                    .text()
                    .catch(() => { })
                    .then(() => scheduleInitialize(initialize));
            })
                .catch(() => { });
            return response;
        };
    })(window, window.fetch);
}
